<template>
	<loader v-if="loading" height="80vh" />
	<div v-else class="container">
		<breadcrumbs
			class="ar"
			:links="[
				{ name: $t('links.home'), link: { name: 'home' } },
				{ name: $t('links.editorial'), link: {}, active: true },
			]"></breadcrumbs>
		<div class="top">
			<div class="title">{{ $t('links.editorial') }}</div>
		</div>
		<div>
			<div class="main">
				<div v-for="staffSerie in staffSeries.sort((a, b) => a.id - b.id)" :key="staffSerie.id">
					<div class="sub-title" v-if="staffSerie.serie">
						{{ staffSerie.serie.name }}
					</div>
					<person
						class="master"
						v-if="staffSerie.staff.length > 0 && staffSerie.staff.find((c) => c.is_boss)"
						:name="staffSerie.staff.find((c) => c.is_boss).publisher.name"
						:rank="staffSerie.staff.find((c) => c.is_boss).position"
						:image="staffSerie.staff.find((c) => c.is_boss).publisher.image"
						:to="{
							name: 'publisher',
							params: {
								id: staffSerie.staff.find((c) => c.is_boss).publisher.id,
								name: staffSerie.staff.find((c) => c.is_boss).publisher.name.replaceSpace(),
							},
						}" />
					<div class="person-group">
						<person
							v-for="staff in staffSerie.staff.filter((c) => !c.is_boss)"
							:key="staff.id"
							:name="staff.publisher.name"
							:rank="staff.position"
							:image="staff.publisher.image"
							:to="{
								name: 'publisher',
								params: { id: staff.publisher.id, name: staff.publisher.name.replaceSpace() },
							}" />
					</div>

					<div v-if="staffSerie.staff.length === 0" class="text-center fs-5">
						{{ $t('editorial.no-data') }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Person from './Person.vue';
import Breadcrumbs from '@/components/Breadcrumbs';
import Loader from '@/components/Loader';
import { mapState } from 'vuex';
export default {
	props: ['loadingSeriesAndVolumes'],

	components: {
		Person,
		Breadcrumbs,
		Loader,
	},

	data() {
		return {
			loading: true,
			staffSeries: [],
		};
	},

	watch: {
		loadingSeriesAndVolumes() {
			this.fetchPublishers();
		},
	},

	computed: {
		...mapState({
			series: (state) => state.series.series,
		}),
	},

	methods: {
		fetchPublishers() {
			if (!this.loadingSeriesAndVolumes) {
				var promises = [];
				promises.push(
					// ftech Editor in Chief
					this.$store.dispatch('series/fetchStaffBySerieId', { id: null }).then((data) => {
						this.staffSeries.push({ id: 0, serie: null, staff: data });
					}),
				);
				this.series.forEach((seire, index) => {
					promises.push(
						// ftech staff for each serie
						this.$store.dispatch('series/fetchStaffBySerieId', { id: seire.id }).then((data) => {
							this.staffSeries.push({ id: index + 1, serie: seire, staff: data });
						}),
					);
				});
				Promise.all(promises).finally(() => {
					this.loading = false;
				});
			}
		},
	},

	mounted() {
		this.fetchPublishers();
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
}
.container > * {
	margin: 0 50px;
}
.top {
	text-align: center;
	padding: 10px 0 30px;
	border-bottom: 2px solid var(--borders-color);
}
.top > * {
	padding: 10px;
}
.title {
	font-size: 36px;
	font-family: changeBold;
	color: var(--green-color);
}
.sub-title {
	font-size: 30px;
	font-family: changeBoldSemi;
	color: var(--green-color);
	padding: 40px 0 20px;
	text-align: center;
}
.main {
	padding: 20px 0 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.person-group {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-evenly;
	align-items: center;
}
.master {
	margin: 0 auto;
	margin-bottom: 30px;
}
@media only screen and (max-width: 992px) {
	.container > * {
		margin: 0 10px;
	}
}
@media only screen and (max-width: 575px) {
	.sub-title {
		font-size: 22px;
	}
}
</style>
